import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { AuthService, UserModel } from 'src/app/core/auth';
import { AuthHTTPService } from 'src/app/core/auth/_services/auth-http';
import { environment } from 'src/environments/environment';
import { PasswordValidators } from './password-validators';
import { StatusCodeData } from 'src/app/core/commons/ultis/status.code';
import { MESSAGE_CONST } from 'src/app/_metronic/core/const/message.const';

@Component({
  selector: 'app-init-password-first',
  templateUrl: './init-password-first.component.html',
  styleUrls: ['./init-password-first.component.scss']
})
export class InitPasswordFirstComponent implements OnInit {
  currentPassword = '1q2w3e*';
  isLoggedIn = false;
  private authenticationEnabled = environment.AuthenticationEnabled;
  isHomeForm: boolean = false;
  formGroup: FormGroup;
  isLoadingForm: boolean = false;
  showPassWd: boolean = false;
  user$: Observable<UserModel>;

  constructor(
    private authService: AuthService,
    private authHttpService: AuthHTTPService,
    private router: Router,
    private userService: AuthService,
    private readonly fb: FormBuilder,
    private toastTr: ToastrService,
    private _cookie: CookieService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.loadForm();
  }

  loadForm() {
    this.formGroup = new FormGroup({
      password: new FormControl('', [Validators.required]),
      cPassword: new FormControl('', [Validators.required])
    }, {
      validators: PasswordValidators.MatchValidator
    });
  }

  changePasswordAction() {
    const formData = this.formGroup.value;
    this.userService.changePassword(formData.password, this.currentPassword)
      .then((res: StatusCodeData<undefined>) => {
        if (res.code === 200) {
          window.location.href = `${window.location.origin}/main`;
        } else if (res.code === 500) {
          this.toastTr.error(MESSAGE_CONST.Error500);
        } else {
          this.toastTr.error(res.message);
        }
      });
  }

  togglePasswordInput() {
    this.showPassWd = !this.showPassWd;
    this.cd.markForCheck();
  }

  logout() {
    this.authService.logout();
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
